import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "container chat-page"
};
const _hoisted_2 = {
  class: "handle-box"
};
const _hoisted_3 = {
  class: "pagination"
};
const _hoisted_4 = {
  class: "handle-box"
};
const _hoisted_5 = {
  class: "pagination"
};
const _hoisted_6 = {
  class: "chat-detail"
};
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
  class: "chat-box chat-page"
};
import { onMounted, ref } from "vue";
import { httpGet, httpPost } from "@/utils/http";
import { ElMessage } from "element-plus";
import { dateFormat, processContent } from "@/utils/libs";
import { Search } from "@element-plus/icons-vue";
import "highlight.js/styles/a11y-dark.css";
import hl from "highlight.js";
import ChatPrompt from "@/components/ChatPrompt.vue";
import ChatReply from "@/components/ChatReply.vue";

// 变量定义

export default {
  __name: 'ChatList',
  setup(__props) {
    const data = ref({
      chat: {
        items: [],
        query: {
          title: "",
          created_at: [],
          page: 1,
          page_size: 15
        },
        total: 0,
        page: 1,
        pageSize: 15,
        loading: true
      },
      message: {
        items: [],
        query: {
          title: "",
          created_at: [],
          page: 1,
          page_size: 15
        },
        total: 0,
        page: 1,
        pageSize: 15,
        loading: true
      }
    });
    const activeName = ref("chat");
    onMounted(() => {
      fetchChatData();
    });
    const handleChange = tab => {
      if (tab === "chat") {
        fetchChatData();
      } else if (tab === "message") {
        fetchMessageData();
      }
    };

    // 搜索对话
    const searchChat = evt => {
      if (evt.keyCode === 13) {
        fetchChatData();
      }
    };

    // 搜索消息
    const searchMessage = evt => {
      if (evt.keyCode === 13) {
        fetchMessageData();
      }
    };

    // 获取数据
    const fetchChatData = () => {
      const d = data.value.chat;
      d.query.page = d.page;
      d.query.page_size = d.pageSize;
      httpPost("/admin/chat/list", d.query).then(res => {
        if (res.data) {
          d.items = res.data.items;
          d.total = res.data.total;
          d.page = res.data.page;
          d.pageSize = res.data.page_size;
        }
        d.loading = false;
      }).catch(e => {
        ElMessage.error("获取数据失败：" + e.message);
      });
    };
    const fetchMessageData = () => {
      const d = data.value.message;
      d.query.page = d.page;
      d.query.page_size = d.pageSize;
      httpPost("/admin/chat/message", d.query).then(res => {
        if (res.data) {
          d.items = res.data.items;
          d.total = res.data.total;
          d.page = res.data.page;
          d.pageSize = res.data.page_size;
        }
        d.loading = false;
      }).catch(e => {
        ElMessage.error("获取数据失败：" + e.message);
      });
    };
    const removeChat = function (row) {
      httpGet("/admin/chat/remove?chat_id=" + row.chat_id).then(() => {
        ElMessage.success("删除成功！");
        fetchChatData();
      }).catch(e => {
        ElMessage.error("删除失败：" + e.message);
      });
    };
    const removeMessage = function (row) {
      httpGet("/admin/chat/message/remove?id=" + row.id).then(() => {
        ElMessage.success("删除成功！");
        fetchMessageData();
      }).catch(e => {
        ElMessage.error("删除失败：" + e.message);
      });
    };
    const mathjaxPlugin = require("markdown-it-mathjax3");
    const md = require("markdown-it")({
      breaks: true,
      html: true,
      linkify: true,
      typographer: true,
      highlight: function (str, lang) {
        if (lang && hl.getLanguage(lang)) {
          // 处理代码高亮
          const preCode = hl.highlight(lang, str, true).value;
          // 将代码包裹在 pre 中
          return `<pre class="code-container"><code class="language-${lang} hljs">${preCode}</code></pre>`;
        }

        // 处理代码高亮
        const preCode = md.utils.escapeHtml(str);
        // 将代码包裹在 pre 中
        return `<pre class="code-container"><code class="language-${lang} hljs">${preCode}</code></pre>`;
      }
    });
    md.use(mathjaxPlugin);
    const showContentDialog = ref(false);
    const dialogContent = ref("");
    const showContent = content => {
      showContentDialog.value = true;
      dialogContent.value = md.render(processContent(content));
    };
    const showChatItemDialog = ref(false);
    const messages = ref([]);
    const showMessages = row => {
      showChatItemDialog.value = true;
      messages.value = [];
      httpGet("/admin/chat/history?chat_id=" + row.chat_id).then(res => {
        const data = res.data;
        for (let i = 0; i < data.length; i++) {
          messages.value.push(data[i]);
        }
      }).catch(e => {
        // TODO: 显示重新加载按钮
        ElMessage.error("加载聊天记录失败：" + e.message);
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_avatar = _resolveComponent("el-avatar");
      const _component_el_popconfirm = _resolveComponent("el-popconfirm");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_tabs, {
        modelValue: activeName.value,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => activeName.value = $event),
        onTabChange: handleChange
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
          label: "对话列表",
          name: "chat"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
            modelValue: data.value.chat.query.user_id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.value.chat.query.user_id = $event),
            modelModifiers: {
              number: true
            },
            placeholder: "账户ID",
            class: "handle-input mr10",
            onKeyup: _cache[1] || (_cache[1] = $event => searchChat($event))
          }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
            modelValue: data.value.chat.query.title,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.value.chat.query.title = $event),
            placeholder: "对话标题",
            class: "handle-input mr10",
            onKeyup: _cache[3] || (_cache[3] = $event => searchChat($event))
          }, null, 8, ["modelValue"]), _createVNode(_component_el_date_picker, {
            modelValue: data.value.chat.query.created_at,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => data.value.chat.query.created_at = $event),
            type: "daterange",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            format: "YYYY-MM-DD",
            "value-format": "YYYY-MM-DD",
            style: {
              "margin-right": "10px",
              "width": "200px",
              "position": "relative",
              "top": "3px"
            }
          }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
            type: "primary",
            icon: _unref(Search),
            onClick: fetchChatData
          }, {
            default: _withCtx(() => _cache[21] || (_cache[21] = [_createTextVNode("搜索")])),
            _: 1
          }, 8, ["icon"])]), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_table, {
              data: data.value.chat.items,
              "row-key": row => row.id,
              "table-layout": "auto"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                prop: "user_id",
                label: "账户ID"
              }), _createVNode(_component_el_table_column, {
                prop: "username",
                label: "账户"
              }), _createVNode(_component_el_table_column, {
                label: "图标"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_avatar, {
                  size: 30,
                  src: scope.row.role.icon
                }, null, 8, ["src"])]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "角色"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row.role.name), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "model",
                label: "模型"
              }), _createVNode(_component_el_table_column, {
                prop: "title",
                label: "标题"
              }), _createVNode(_component_el_table_column, {
                prop: "msg_num",
                label: "消息数量"
              }), _createVNode(_component_el_table_column, {
                prop: "token",
                label: "消耗算力"
              }), _createVNode(_component_el_table_column, {
                label: "创建时间"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(scope.row["created_at"])), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "操作",
                width: "180"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_button, {
                  size: "small",
                  type: "primary",
                  onClick: $event => showMessages(scope.row)
                }, {
                  default: _withCtx(() => _cache[22] || (_cache[22] = [_createTextVNode("查看")])),
                  _: 2
                }, 1032, ["onClick"]), _createVNode(_component_el_popconfirm, {
                  title: "确定要删除当前记录吗?",
                  onConfirm: $event => removeChat(scope.row)
                }, {
                  reference: _withCtx(() => [_createVNode(_component_el_button, {
                    size: "small",
                    type: "danger"
                  }, {
                    default: _withCtx(() => _cache[23] || (_cache[23] = [_createTextVNode("删除")])),
                    _: 1
                  })]),
                  _: 2
                }, 1032, ["onConfirm"])]),
                _: 1
              })]),
              _: 1
            }, 8, ["data", "row-key"])]),
            _: 1
          }), _createElementVNode("div", _hoisted_3, [data.value.chat.total > 0 ? (_openBlock(), _createBlock(_component_el_pagination, {
            key: 0,
            background: "",
            layout: "total,prev, pager, next",
            "hide-on-single-page": true,
            "current-page": data.value.chat.page,
            "onUpdate:currentPage": _cache[5] || (_cache[5] = $event => data.value.chat.page = $event),
            "page-size": data.value.chat.pageSize,
            "onUpdate:pageSize": _cache[6] || (_cache[6] = $event => data.value.chat.pageSize = $event),
            onCurrentChange: _cache[7] || (_cache[7] = $event => fetchChatData()),
            total: data.value.chat.total
          }, null, 8, ["current-page", "page-size", "total"])) : _createCommentVNode("", true)])]),
          _: 1
        })), [[_directive_loading, data.value.chat.loading]]), _createVNode(_component_el_tab_pane, {
          label: "消息记录",
          name: "message"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_input, {
            modelValue: data.value.message.query.user_id,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => data.value.message.query.user_id = $event),
            modelModifiers: {
              number: true
            },
            placeholder: "账户ID",
            class: "handle-input mr10",
            onKeyup: _cache[9] || (_cache[9] = $event => searchMessage($event))
          }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
            modelValue: data.value.message.query.content,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => data.value.message.query.content = $event),
            placeholder: "消息内容",
            class: "handle-input mr10",
            onKeyup: _cache[11] || (_cache[11] = $event => searchMessage($event))
          }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
            modelValue: data.value.message.query.model,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => data.value.message.query.model = $event),
            placeholder: "模型",
            class: "handle-input mr10",
            onKeyup: _cache[13] || (_cache[13] = $event => searchMessage($event))
          }, null, 8, ["modelValue"]), _createVNode(_component_el_date_picker, {
            modelValue: data.value.message.query.created_at,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => data.value.message.query.created_at = $event),
            type: "daterange",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            format: "YYYY-MM-DD",
            "value-format": "YYYY-MM-DD",
            style: {
              "margin-right": "10px",
              "width": "200px",
              "position": "relative",
              "top": "3px"
            }
          }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
            type: "primary",
            icon: _unref(Search),
            onClick: fetchMessageData
          }, {
            default: _withCtx(() => _cache[24] || (_cache[24] = [_createTextVNode("搜索")])),
            _: 1
          }, 8, ["icon"])]), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_table, {
              data: data.value.message.items,
              "row-key": row => row.id,
              "table-layout": "auto"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                prop: "user_id",
                label: "账户ID"
              }), _createVNode(_component_el_table_column, {
                prop: "username",
                label: "账户"
              }), _createVNode(_component_el_table_column, {
                label: "角色"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_avatar, {
                  size: 30,
                  src: scope.row.icon
                }, null, 8, ["src"])]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "model",
                label: "模型"
              }), _createVNode(_component_el_table_column, {
                label: "消息内容"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_text, {
                  style: {
                    "width": "200px"
                  },
                  truncated: "",
                  onClick: $event => showContent(scope.row.content)
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.content), 1)]),
                  _: 2
                }, 1032, ["onClick"])]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "token",
                label: "算力"
              }), _createVNode(_component_el_table_column, {
                label: "创建时间"
              }, {
                default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(scope.row["created_at"])), 1)]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "操作",
                width: "180"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_button, {
                  size: "small",
                  type: "primary",
                  onClick: $event => showContent(scope.row.content)
                }, {
                  default: _withCtx(() => _cache[25] || (_cache[25] = [_createTextVNode("查看")])),
                  _: 2
                }, 1032, ["onClick"]), _createVNode(_component_el_popconfirm, {
                  title: "确定要删除当前记录吗?",
                  onConfirm: $event => removeMessage(scope.row)
                }, {
                  reference: _withCtx(() => [_createVNode(_component_el_button, {
                    size: "small",
                    type: "danger"
                  }, {
                    default: _withCtx(() => _cache[26] || (_cache[26] = [_createTextVNode("删除")])),
                    _: 1
                  })]),
                  _: 2
                }, 1032, ["onConfirm"])]),
                _: 1
              })]),
              _: 1
            }, 8, ["data", "row-key"])]),
            _: 1
          }), _createElementVNode("div", _hoisted_5, [data.value.message.total > 0 ? (_openBlock(), _createBlock(_component_el_pagination, {
            key: 0,
            background: "",
            layout: "total,prev, pager, next",
            "hide-on-single-page": true,
            "current-page": data.value.message.page,
            "onUpdate:currentPage": _cache[15] || (_cache[15] = $event => data.value.message.page = $event),
            "page-size": data.value.message.pageSize,
            "onUpdate:pageSize": _cache[16] || (_cache[16] = $event => data.value.message.pageSize = $event),
            onCurrentChange: _cache[17] || (_cache[17] = $event => fetchMessageData()),
            total: data.value.message.total
          }, null, 8, ["current-page", "page-size", "total"])) : _createCommentVNode("", true)])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: showContentDialog.value,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => showContentDialog.value = $event),
        title: "消息详情",
        class: "chat-dialog",
        style: {
          "--el-dialog-width": "60%"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
          class: "chat-line",
          innerHTML: dialogContent.value
        }, null, 8, _hoisted_7)])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: showChatItemDialog.value,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => showChatItemDialog.value = $event),
        title: "对话详情",
        class: "chat-dialog",
        style: {
          "--el-dialog-width": "60%"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item.id
          }, [item.type === 'prompt' ? (_openBlock(), _createBlock(ChatPrompt, {
            key: 0,
            data: item
          }, null, 8, ["data"])) : item.type === 'reply' ? (_openBlock(), _createBlock(ChatReply, {
            key: 1,
            "read-only": true,
            data: item
          }, null, 8, ["data"])) : _createCommentVNode("", true)]);
        }), 128))])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};